export const environment = {
  production: true,
  // apiURL:"https://skillflodemo.sifylivewire.com"
  apiURL:"http://localhost:3000",
   billingUrl: "https://pricing-engine.sifylivewire.com"
};
